import type { createStore} from "jotai";
import { Provider as JotaiProvider } from "jotai";
import {
    createContext,
    type PropsWithChildren,
    useContext,
    useEffect,
    useReducer,
} from "react";

const ResetContext = createContext<CallableFunction>(() => { });

let globalResetFn: (() => void) | null = null;

export const resetJotaiStore = () => {
    if (globalResetFn) {
        globalResetFn();
    } else {
        console.warn('Reset function not initialized yet');
    }
};

const reset = 0;

const reset_reducer = () => {
    return Math.random();
};

export const ResetProvider = (
    props: PropsWithChildren & {
        store?: ReturnType<typeof createStore>;
    }
) => {
    const [reset_a, reset_atoms] = useReducer(reset_reducer, reset);

    useEffect(() => {
        globalResetFn = reset_atoms;

        return () => {
            globalResetFn = null;
        };
    }, [reset_atoms]);

    return (
        <ResetContext.Provider value={reset_atoms}>
            <JotaiProvider key={reset_a} store={props.store}>
                {props.children}
            </JotaiProvider>
        </ResetContext.Provider>
    );
};

export const useResetJotai = () => useContext(ResetContext);